import { InjectionToken } from "@angular/core";

export const TitleServiceToken = new InjectionToken<ITitleService>(
  "environment"
);

export interface ITitleService {
  setTitle(title: string);
}
